var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiagonalArrowIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 15,
    viewBox: "0 0 11 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 14.9333,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_18:315",
    transform: "scale(0.0424242 0.03125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_18:315",
    width: 30,
    height: 32,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAgCAYAAAAFQMh/AAABFUlEQVRYCe3UPQ6CMBQH8J7GjclbcAUPweZB2NlNjDdw9wDGGIJxciHRgcQJhmf+JM/oiy39CjgwNA9K+n7ta4vquo6maGoKFOYMj7bfc6n/p9Tr24EWp413011Xqz0OwYNgDPbFg2FfPArsg0eDXfGoMJKtrnurkx4V3j4uViiuYTTYBY0G61BT2YNXrEPRj+S6ex4ED6Gc/BfO32Qc/GXaopxY4twvoxF2RTn5J859Mhrh4/NOy/Pu6+rwnspE8p1x9Nd1TXmeU1EU1DRNfyaMMAZ94rYoTwI4ntM0JaVU37Iss4MZd0UZb9v2jQJPksQe5iS+EavkFaPkyDNYal9Mjquqisqy7NFRYTmR0VY8w5OV+gUeT8PFqvw60QAAAABJRU5ErkJggg=="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagonalArrowIcon);
export default __webpack_public_path__ + "static/media/diagonal-arrow-icon.d36cc4b8.svg";
export { ForwardRef as ReactComponent };